<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1 />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MdtfAddMain from '@/views/StockManagement/MdtfManage/TabChild/MdtfAddMainO';
export default {
  name: 'MdtfAddO',
  components: {
    childTab1: MdtfAddMain
  },
  data() {
    return {
      activeName: 'first'
    };
  },
  created() {}
};
</script>

<style scoped></style>
